module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var DataObject = function(layer) {
		this._index = fox.clone(layer._indexedCollection);
		this._pointer = 0;
		this._objClass = 'DataObject'; 
	};

	fox.registerService('DataObject', fox.extend(DataObject, fox.mixin({
		get: function(name) {
			if (name[0] == '_') return this.getMetaValue(name);
			
			if(/\./.test(name)) {
				var tmp = /^(.*?)\.(.*?)$/.exec(name);
				var rel = this.relation(tmp[1]);
				return rel.getObject().get(tmp[2]);
			}
			return this._index && this._index[this._pointer] ? this._index[this._pointer][name] : false;
		},
		getCount: function() {
			return this._index.length;
		},
		getRelatedObject: function (name) {
			var dl = this.relation(name);
			return dl ? dl.iterateObject('first') : false;
		},
		relation: function(name, dl) {
			var data = this.get(name);
			if (!data || !fox.isDl(data)) {
				return fox.hydrateDl(data, dl);
			}
			return data;
		},
		getMetaValue: function(name) {
			return fox.arrayRelation(this._index[this._pointer], name);
		},
		getAll: function() {
			return this._index[this._pointer] || false;
		},
		set: function(name, value) {
			this._index[this._pointer] && (fox.isObject(name) ? (this._index[this._pointer] = name) : (this._index[this._pointer][name] = value));
			return this;
		},
		merge: function(values) {
			this._index[this._pointer] && fox.merge(this._index[this._pointer], values);
			return this;
		},
		toJSON: function() {
			var value;
			return (value = this.getAll()) ? JSON.strigify(value) : false;
		},
		end: function() {
			this._pointer = this._index.length - 1;
		},
		
		//iteration methods
		next: function() {
			var max = this._index.length;
			return (++this._pointer < max) ? this : (this._pointer = max - 1) && false;
		},

		prev: function() {
			return (--this._pointer >= 0) ? this : (this._pointer = 0) || false;
		},
		
		reset: function() {
			return this._pointer = 0;
		}
	}), null, 'DataObject'));
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-services/lib/services/dataobject.js
// module id = 240
// module chunks = 0